export const fontFamily = {
    primary: "Montserrat",
    secondary: "Inter"
}